// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1EL8j","label":"Category_label__1aXGd","content":"Category_content__1NL9z","header":"Category_header__326AM","location":"Category_location__l_E_0"};